import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import { Theme, useTheme } from "@mui/material/styles";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export const NoticesInactive: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ height: "100%", bgcolor: "background.paper", py: 7.5 }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" color="textSecondary">
            <span style={{ color: theme.palette.primary.main }}>Enforcement</span> is not active in your community
          </Typography>
        </Box>
        <Stack sx={{ mb: 6.5 }} spacing={4}>
          <Typography variant="h5">What are my Options?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4 }}>
            <OptionSurface title="Automated Enforcement">
              Fully automate enforcement with citations sent directly by mail. <br />
              <br />
              Optionally, have administrative parking enforcement personnel review citations prior to issuance.
            </OptionSurface>
            <OptionSurface title="Automated Invoicing">
              Drive turnover and compliance by automating curb access payments, with invoices sent by mail for the
              amount owed—just like a toll road.
              <br />
              <br />
              Perfect for areas where regulations prevent issuing citations by mail.
            </OptionSurface>
            <OptionSurface title="Directed Enforcement">
              Boost efficiency by alerting staff to violations in real-time. <br />
              <br />A great starting point for transitioning to full automation.
            </OptionSurface>
          </Box>
        </Stack>
        <Box sx={{ mb: 5.5, display: "flex", flexDirection: "row", alignItems: "center", gap: 8 }}>
          <Typography variant="h5">Enforcement Metrics</Typography>
          <Stack direction="row" spacing={12}>
            <Metric title="Double Parking" value="94%" variant="down" />
            <Metric title="Parking Compliance" value="101%" variant="up" />
            <Metric title="Revenue Generated" value="9X" variant="up" />
          </Stack>
        </Box>
        <Box>
          <Typography variant="h4">
            Ready to enhance your <span style={{ color: theme.palette.primary.main }}>Enforcement</span>?
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const OptionSurface: React.FC<OptionSurfaceProps> = ({ title, children }) => (
  <Paper
    sx={{
      p: 1.25,
      backgroundColor: (theme: Theme) => theme.palette.grey[50],
      width: "357px",
      minWidth: "357px",
      height: "286px",
    }}
  >
    <Stack spacing={1.5}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Typography variant="h4bxs">{title}</Typography>
      </Box>
      <Box>
        <Typography variant="body1">{children}</Typography>
      </Box>
    </Stack>
  </Paper>
);

interface OptionSurfaceProps {
  title: string;
}

const Metric: React.FC<MetricProps> = ({ title, value, variant }) => {
  const ArrowIcon = variant === "up" ? ArrowUpwardIcon : ArrowDownwardIcon;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <Box display="flex" alignItems="center" gap={0.5}>
        <ArrowIcon color={variant === "up" ? "success" : "error"} style={{ fontSize: "28px" }} />
        <Typography
          sx={{ color: (theme: Theme) => (variant === "up" ? theme.palette.success.main : theme.palette.error.main) }}
          variant="h5"
        >
          {value}
        </Typography>
      </Box>
      <Typography variant="caption">{title}</Typography>
    </Box>
  );
};

interface MetricProps {
  title: string;
  value: string;
  variant: "up" | "down";
}

export default NoticesInactive;
